import { createContext } from 'react';

/**
 * Lets a subtree decide where the select menus inside it portal to.
 *
 * `undefined` (the default) means "not specified" and leaves resolution to the
 * modal and stack page contexts. An explicit `null` renders the menu inline.
 */
export const SelectMenuPortalTargetContext = createContext<
  HTMLElement | null | undefined
>(undefined);
